module.exports = __webpack_public_path__ + "static/img/助力零售.47cbfe7d.png";